export const initialState = {
    loading: false,
    error: null,
}